/** Trial length in days (§11). Configurable, not scattered through the code. */
export const TRIAL_DURATION_DAYS = 14;

/** Invite tokens must not be guessable (§26, §64). */
export const INVITE_TOKEN_BYTES = 16;

/**
 * Имя платформы, как его читает человек (§бэклог 12).
 *
 * Одно на всех: шапка, экран гостя, письмо, форма регистрации. Разные написания
 * в разных углах читаются как разные продукты, а «Creativitas» латиницей — это
 * имя репозитория, а не то, что Дарья говорит вслух.
 */
export const APP_NAME = 'Академия Креативитас';

/**
 * Куда писать, когда платформа сама помочь не может. Тот же ящик, с которого
 * уходят письма: ответ на письмо платформы попадает туда же.
 */
export const SUPPORT_EMAIL = 'support@creativitas.ru';

export const DEFAULT_SERVER_PORT = 4010;
export const DEFAULT_WEB_PORT = 5180;

/** Deck slugs used by seed data and by the preset spreads. */
export const DECK_SLUGS = {
  talents: 'talents',
  roles: 'roles',
  sage: 'sage',
  bazaar: 'bazaar',
  dragon: 'dragon',
  master: 'master',
  inspiration: 'inspiration',
} as const;

export const SPREAD_SLUGS = {
  placeInTheSun: 'place-in-the-sun',
  whyNotVisible: 'why-not-visible',
  freeform: 'freeform',
  /* «Шахматы» — три МАК-сессии на своей доске. Колода у них не закреплена за
     позицией: «Все колоды могут быть использованы» (Дарья, 6 сентября). */
  chessShadow: 'chess-shadow',
  chessBusiness: 'chess-business',
  chessOwnGame: 'chess-own-game',
} as const;

export const GAME_SLUGS = {
  sunOfTalent: 'sun-of-talent',
  /* Демоверсия: своя запись каталога, поле и колоды — от полной игры. */
  sunOfTalentDemo: 'sun-of-talent-demo',
} as const;

/**
 * Player marker colours, assigned by join order (§39).
 *
 * This is the product layer, not the platform: a pawn is an object on the
 * board, so it is allowed to be louder than the interface around it. The
 * previous muted set failed at the one job it has — terracotta and ochre sat
 * ΔE 12 apart, violet and mauve ΔE 13, and at the size of a marker on the art
 * or a chip on a ray they read as the same colour.
 *
 * Every pair here is at least ΔE 37 apart in normal vision and ΔE 23 under
 * deuteranopia, each carries white initials at 4.8:1 or better, and none comes
 * within ΔE 20 of the brand teal, the board's blue or its gold — so a pawn is
 * never mistaken for the interface or for the artwork under it.
 *
 * Order alternates warm and cool, because the first players to join take the
 * first colours and a small party should not get two neighbours in one family.
 */
export const PLAYER_LANE_COLORS = [
  '#c33f31',
  '#125790',
  '#0e6827',
  '#7243a0',
  '#674407',
  '#c83a7b',
] as const;
